import React, {Component} from 'react';
import ValidationMessage from "./validationMessage";
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui/ui/widgets/datepicker';
import  'jquery-ui/themes/base/datepicker.css'
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/theme.css'
import '../style/formGroupDate.css'
import EditIcon from "./icons/editIcon";
import {checkIfQuestionAnswerUpdateRequiresARAGApproval} from "../helpers/approvalSettings/functions";
import FormGroupPlainText from "./formGroupPlainText";
import calendarIcon from '../assets/newApplication/calendar.svg';

class FormGroupDate extends Component {
    initializeDatepicker(minDate, maxDate) {
        $('#' + this.props.Name).datepicker({
            dateFormat: "dd/mm/yy",
            yearRange: "1900:2100",
            minDate: minDate ? minDate : "01/01/1900",
            maxDate: maxDate,
            changeYear: true,
            changeMonth: true,
            showAnim: '',
            onSelect: (date) => {
                this.props.HandleInputChange(this.refs.input.name, date, minDate, maxDate);
            }
        });
        $('#' + this.props.Name).attr('placeholder', 'DD/MM/YYYY');
    }

    componentDidMount() {
        this.initializeDatepicker(this.props.Min, this.props.Max);
    }

    componentDidUpdate(prevProps) {
        // Check if relevant props (Min, Max, Name) have changed
        if (this.props.Min !== prevProps.Min || this.props.Max !== prevProps.Max || this.props.Name !== prevProps.Name) {
            if ($('#' + this.props.Name).data('datepicker')) {
                $('#' + this.props.Name).datepicker("destroy"); // Destroy only if it exists
            }
            this.initializeDatepicker(this.props.Min, this.props.Max);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.initializeDatepicker(nextProps.Min, nextProps.Max);
    }

    componentWillUnmount() {
        $('#' + this.props.Name).datepicker('destroy');
    }

    render() {
        const { isPlain, pattern, title, labelAsALink, onLabelClick } = this.props;
        if(isPlain) {
            return (
                <FormGroupPlainText
                    labelAsALink={labelAsALink}
                    onLabelClick={onLabelClick}
                    RightWrapper={this.props.RightWrapper}
                    rightData={this.props.rightData}
                    LeftWrapper="col-sm-3"
                    InputWrapper={this.props.InputWrapper}
                    Label={this.props.Label}
                    Text={this.props.Value}
                />
            )
        }

        return (
            <div className="form-group">
                <div className="col-sm-3">
                    <label className="control-label.text-left formGroup-textInput-label">
                        {this.props.Label}
                        {this.props.Required ?
                            <span>{' '}*</span>
                            :
                            null
                        }
                    </label>
                </div>
                <div className={this.props.InputWrapper}>
                    <input
                        title={title}
                        pattern={pattern}
                        autoComplete={this.props.autoComplete}
                        ref="input"
                        id={this.props.Name}
                        disabled={this.props.Disabled} type="text" required={this.props.Required}
                        max={this.props.Max} min={this.props.Min}
                        className="form-control formGroupDate-input datepicker"
                        placeholder={this.props.Placeholder} name={this.props.Name} value={this.props.Value}
                        onChange={(name, value, min,max) =>this.props.HandleInputChange(name, value, this.props.Min,this.props.Max)}/>
                    <div className="formGroupDate-icon-wrapper">
                        <img src={calendarIcon} alt="calendar"/>
                    </div>


                    {this.props.ErrorExists ?
                        <ValidationMessage Label={this.props.ErrorMessage}/>
                        :
                        null
                    }
                </div>
                <div className={this.props.RightWrapper}>{this.props.rightData ? this.props.rightData : null}</div>
            </div>
        )
    }
}
;

export default FormGroupDate
